export default function AboutHero() {
  return (
    <section className="relative w-full h-[320px] md:h-[420px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20warm%20and%20inviting%20illustration%20of%20a%20cozy%20reading%20space%20with%20bookshelves%20and%20soft%20lighting%2C%20golden%20amber%20color%20palette%2C%20comfortable%20atmosphere%2C%20artistic%20webtoon%20style%2C%20warm%20gradients&width=1920&height=800&seq=about-hero-01&orientation=landscape"
          alt="关于韩漫网 - 高清韩国漫画在线阅读平台"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <h1 className="text-2xl md:text-4xl font-black text-white mb-2 md:mb-3"
          style={{ fontFamily: "var(--font-heading)" }}>
          关于韩漫网
        </h1>
        <p className="text-sm md:text-base italic text-white/80 mb-1"
          style={{ fontFamily: "var(--font-heading)" }}>
          为热爱韩漫的你而生
        </p>
        <p className="text-xs md:text-sm text-white/60 max-w-md mx-auto">
          致力于打造最优质的中文韩漫在线阅读平台
        </p>
      </div>
    </section>
  );
}